import React from 'react';
import PropTypes from 'prop-types';

import Box from 'components/atoms/Box/Box';
import Typography from 'components/atoms/Typography/Typography';
import Paragraph from 'components/atoms/Paragraph/Paragraph';

import MuiListItem from '@material-ui/core/ListItem';
import { useListItemStyles } from './listItemStyles';

/**
 * List item based on https://material-ui.com/api/list-item/
 * @param {*} props All props can be found in docs https://material-ui.com/api/list-item/#listitem-api
 */
export default function ListItem(props) {
  const { children, index } = props;

  const classes = useListItemStyles();

  return (
    <MuiListItem alignItems="flex-start" dense>
      {index ? (
        <Box className={classes.ordinal}>
          <Typography color="inherit">{index}</Typography>
        </Box>
      ) : (
        <Box mr={1}>
          <Typography>&bull;</Typography>
        </Box>
      )}
      <Paragraph>{children}</Paragraph>
    </MuiListItem>
  );
}

ListItem.propTypes = {
  /**
   * Text value.
   */
  children: PropTypes.string.isRequired,
  /**
   * In case of ordered list, number representing item ordinal.
   */
  index: PropTypes.number,
};
